import isEmpty from 'lodash/isEmpty';
import API_URL from "../constant/api.config";
import { trim } from "lodash";
import axiosInstance from '../axiosHttp';
import { setAuthHeaders } from "../utils/common";

export const getUserList = (offset, limit, columnName = "created_at", sortDirection = "DESC", filterValue, searchTxt = null) => async (dispatch) => {
    searchTxt = trim(searchTxt);
    searchTxt = btoa(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    const headers = setAuthHeaders();
    return await axiosInstance.get(API_URL + '/users/' + offset + '/' + limit + '/' + columnName + '/' + sortDirection + '/' + filterValue + searchQueryString,
        {
            headers
        }
    ).then((response) => {
        // console.log("USER API response ============== ", response);
        if (response.status === true) {
            dispatch({ type: "LIST_USERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const createUser = (data) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + '/users', data, { headers }).then((response) => {
        // console.log(" API response in userAction File ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}

export const deleteUser = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.delete(API_URL + '/users/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const getUser = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.get(API_URL + '/user/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const updateUser = (id, data) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/update-user/' + id, data, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========= ", err);
    })
}

export const changePswd = (data) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/change-password', data, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}

export const changePswdByUser = (data) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/change-user-password', data, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}